export default __webpack_public_path__ + "transfix-maps/icons/P2.fdb00711cd1ffb1d000a76d19d20dbea.png";